import { Link } from "react-router-dom";
import { LogoMark } from "./Reveal";

const EXPLORE = [
  { label: "Welcome", href: "/" },
  { label: "Experiences", href: "/experiences" },
  { label: "Group Packages", href: "/group-packages" },
  { label: "The Island", href: "/the-island" },
  { label: "The Lodge", href: "/the-lodge" },
  { label: "Contact", href: "/contact" },
];

const TOURS = [
  { label: "Sea Safari & Wildlife Tour", href: "/experiences/sea-safari" },
  { label: "High-Speed RIB Tours", href: "/experiences/boat-trips" },
  { label: "Kayaking, SUP & Beach Sauna", href: "/experiences/kayaking-sup" },
  { label: "Beach Sauna & Seaweed", href: "/experiences/sauna-experience" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-navy-950 pb-10 pt-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" data-testid="footer-logo" className="inline-flex">
              <img src="/images/logo-dark.png" alt="The Adventure Islands" className="h-14 w-auto" />
            </a>
            <p className="mt-6 font-serif text-lg italic text-gold">Travel. Discover. Learn.</p>
            <p className="mt-4 max-w-sm text-sm font-light leading-relaxed text-mist">
              Unforgettable private island adventures in Clew Bay, County Mayo &mdash; safe,
              seamless and incredibly fun, from start to finish.
            </p>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">Explore</h3>
            <ul className="mt-6 space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm font-light text-ivory/75 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">Experiences</h3>
            <ul className="mt-6 space-y-3">
              {TOURS.map((t) => (
                <li key={t.href}>
                  <Link
                    to={t.href}
                    className="text-sm font-light text-ivory/75 transition-colors hover:text-gold"
                  >
                    {t.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">Contact</h3>
            <ul className="mt-6 space-y-3 text-sm font-light text-ivory/75">
              <li>Collanmore Island, Clew Bay, Westport, County Mayo, Ireland</li>
              <li>
                <a href="tel:+353862518252" className="transition-colors hover:text-gold">+353 86 251 8252</a>
              </li>
              <li>
                <a href="mailto:info@theadventureislands.com" className="transition-colors hover:text-gold">
                  info@theadventureislands.com
                </a>
              </li>
              <li className="text-mist">Open daily 09:00 &ndash; 18:00</li>
              <li>
                <a
                  href="https://www.collanmoreislandlodge.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-collanmore-lodge"
                  className="transition-colors hover:text-gold"
                >
                  Our sister island lodge &mdash; Collanmore Island Lodge
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 text-[11px] tracking-wide text-mist sm:flex-row">
          <p>&copy; {new Date().getFullYear()} The Adventure Islands. All rights reserved.</p>
          <p className="uppercase tracking-[0.2em]">Collanmore &middot; Clew Bay &middot; Westport &middot; Ireland</p>
        </div>
      </div>
    </footer>
  );
}
